import { env } from "src/env";

const resources = {
    logoUri: env.PUBLIC_URL + "/logo.svg"
};

export default resources;
                                           